import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ClientEnv } from 'constants/Chat.constants';
import { JupiterClientEnvironment } from 'constants/Chat.constants';

import { projectInit } from 'actions';

export interface WebChatPanelState {
  isWebChatPanelOpen: boolean;
  clientEnv: ClientEnv;
}

const initialState: WebChatPanelState = {
  isWebChatPanelOpen: false,
  clientEnv: JupiterClientEnvironment.DRAFT,
};

const webChatPanelSlice = createSlice({
  name: 'webChatPanel',
  initialState,
  reducers: {
    openWebChatPanel: state => {
      state.isWebChatPanelOpen = true;
    },
    closeWebChatPanel: state => {
      state.isWebChatPanelOpen = false;
    },
    toggleWebChatPanel: state => {
      state.isWebChatPanelOpen = !state.isWebChatPanelOpen;
    },
    setWebClientEnv: (
      state,
      { payload: clientEnv }: PayloadAction<ClientEnv>,
    ) => {
      state.clientEnv = clientEnv;
    },
  },
  extraReducers: builder => {
    builder.addCase(projectInit, () => {
      return { ...initialState };
    });
  },
});

export const {
  openWebChatPanel,
  closeWebChatPanel,
  toggleWebChatPanel,
  setWebClientEnv,
} = webChatPanelSlice.actions;

export default webChatPanelSlice.reducer;
